import { StatusBadge } from '@vrplatform/components';
import type { ResponseData } from '@vrplatform/data';
import { formatCurrency, type Maybe } from '@vrplatform/utils';

type PaidStatus = ResponseData<'get:/reservations/{id}'>['payment']['status'];

type Props = {
  paidStatus: Maybe<PaidStatus>;
  paymentsCentTotal: number;
  reservationCentTotal: number;
  currency: string | undefined;
};

export const ReservationPaymentStatusBadge = ({
  paidStatus,
  currency,
  paymentsCentTotal,
  reservationCentTotal,
}: Props) => {
  if (!paidStatus) return null;

  const balance = reservationCentTotal - paymentsCentTotal;

  switch (paidStatus) {
    case 'paid':
      return <StatusBadge label="Paid" status="success" />;
    case 'unpaid':
      return <StatusBadge label="Unpaid" status="unpaid" />;
    case 'overpaid':
      return (
        <StatusBadge
          label={`Overpaid (${formatCurrency(balance / 100, currency)})`}
          status="overpaid"
        />
      );
    case 'underpaid':
      return (
        <StatusBadge
          label={formatCurrency(balance / 100, currency)}
          status="underpaid"
          tooltip="Not fully paid"
        />
      );
    default:
      return <StatusBadge label="Co-host" status="shared" />;
  }
};
